import { Action } from 'redux';
import { AxiosResponse } from 'axios';
import { IUpdateRetailerMetaParams } from '../api/Retailers/IUpdateRetailerMetaParams';
import { updateRetailerMeta } from '../api/Retailers/retailersApi';

export const UPDATE_RETAILER_META_REQUEST = 'UPDATE_RETAILER_META_REQUEST';

export const UPDATE_RETAILER_META_RESPONSE = 'UPDATE_RETAILER_META_RESPONSE';

export const UPDATE_RETAILER_META_ERROR = 'UPDATE_RETAILER_META_ERROR';

export interface IUpdateRetailerMetaResponse extends Action {
  type: typeof UPDATE_RETAILER_META_RESPONSE;
}

export interface IUpdateRetailerMetaError extends Action {
  type: typeof UPDATE_RETAILER_META_ERROR;
  error?: string;
}

export const updateRetailerMetaRequest =
 (parameters: IUpdateRetailerMetaParams,
  onSuccess: () => void,
  onFailure: (error?: string) => void): any => {
   return (dispatch : any) => {

     dispatch({
       type: UPDATE_RETAILER_META_REQUEST,
     });

     return updateRetailerMeta(parameters)
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          dispatch({
            type: UPDATE_RETAILER_META_RESPONSE,
          });

          onSuccess();

        } else {
          onError(dispatch);
          onFailure('Failed to update retailer settings');
        }
      })
      .catch((err) => {
        console.log(err);
        onFailure('Failed to update retailer settings');
        onError(dispatch);
      });
   };
 };

const onError = (dispatch: any) => dispatch({
  type: UPDATE_RETAILER_META_ERROR,
});
